function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#545454",
  d: "M16.836 6.87a3.984 3.984 0 00-2.851-2.8A4.247 4.247 0 0010 5.505a4.249 4.249 0 00-3.986-1.44A3.984 3.984 0 003.163 6.87a3.826 3.826 0 00.982 3.833l5.517 5.046c.19.174.483.174.675 0l5.534-5.062a3.819 3.819 0 00.965-3.817z",
  fillRule: "evenodd"
})));